import type { ReactNode } from "react";
import { Navbar } from "@/components/layout/Navbar";

/** Page layout: the navigation chrome, and the screen below it. */
export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh">
      <Navbar />
      <main>{children}</main>
    </div>
  );
}
